/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const NasalBleedingIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path d='M25.088 50.039c-7.4 0-14-3.3-17.4-8.9-3.4-5.4-3.5-12.1-.3-18.4 3.7-6.7 7.9-13.2 12.5-19.3 1.5-2.2 3.4-3.4 5.3-3.4 1.2 0 3.1.5 4.8 3 5 6.5 9.4 13.5 13.2 20.8 2.8 6 2.5 12.3-.7 17.4-3.5 5.4-9.8 8.7-17 8.8h-.4zm0-48c-1.2 0-2.5.9-3.6 2.6-4.5 6.1-8.7 12.5-12.3 19.1-2.8 5.6-2.7 11.6.3 16.4 3.1 5 9.1 8 15.9 8 6.5 0 12.3-3 15.4-7.8 2.9-4.5 3.1-10.2.6-15.5-3.7-7.1-8.1-14-13-20.5-.9-1.2-2-2.3-3.3-2.3z' />
		</svg>
	)
}

export default NasalBleedingIcon
